import React from "react";
import { EWsrvTransform, IMediaItem } from "../../lib";
import { ILinkFunc } from "../../lib/util";
import { Button } from "../Button/Button";
import { BackgroundImage, WsrvImage, IWsrvImageProps } from "../Media";
import Heading from "./Heading";

export enum EImageLayout {
    left = "left",
    right = "right"
}

export interface IImageWithOverlappedTextBladeProps {
    classNames?: string;
    textWrapperClassNames?: string;
    layout?: EImageLayout;
    backgroundImage: IMediaItem;
    leadImage: IMediaItem;
    title: string;
    titleClassNames?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    text: string;
    buttonClassNames?: string;
    callToAction?: { href: string; text?: string; target?: string }
    leadImageProps?: Partial<IWsrvImageProps>;
    linkFunc?: ILinkFunc;
    htmlIdAttribute?: string;
}

export const ImageWithOverlappedTextBlade: React.FC<IImageWithOverlappedTextBladeProps> = ({
    classNames = "",
    textWrapperClassNames = "",
    layout = EImageLayout.left,
    backgroundImage,
    leadImage,
    title,
    titleClassNames = "",
    titleHeadingLevel = "h2",
    text,
    buttonClassNames = "",
    callToAction,
    leadImageProps,
    linkFunc,
    htmlIdAttribute,
}) => {

    const linkf = linkFunc || ((props) => <a {...props} />);

    return (
        <BackgroundImage
            htmlIdAttribute={htmlIdAttribute}
            src={backgroundImage.url}
            className={`relative p-4 md:py-40 w-full lg:min-h-screen flex flex-col justify-center items-center ${classNames}`}
        >
            <div className="relative w-full max-w-6xl flex flex-row flex-wrap md:flex-nowrap justify-center items-center">
                <WsrvImage
                    urlParams={{
                        originURL: leadImage.url,
                        preset: EWsrvTransform.limit,
                    }}
                    imgProps={{
                        className: `w-full aspect-[4/5]`,
                        wrapperClassName: `w-11/12 md:w-[45%] relative z-10 md:z-0 ${layout == EImageLayout.left ? "" : "md:order-last"}`,
                        wrapperProps: {
                            style: {
                                display: "block",
                            }
                        }
                    }}
                    {...leadImageProps}
                />
                <div className={`w-full md:w-[55%] relative flex flex-col items-start pt-16 pb-7 px-7 md:pt-10 lg:pt-16 lg:pb-20 lg:px-10 -mt-12 md:mt-0 bg-body-bg z-0 md:z-10 ${layout == EImageLayout.left ? "md:-ml-[6%]" : "md:-mr-[6%] md:order-first"} ${textWrapperClassNames}`}>
                    <Heading headingLevel={titleHeadingLevel} className={`${titleClassNames}`}>{title}</Heading>
                    <div dangerouslySetInnerHTML={{ __html: text }}></div>
                    {callToAction && (
                        <Button
                            linkProps={{
                                href: callToAction.href,
                                className: `uppercase underline mt-7 md:mt-9 ${buttonClassNames}`
                            }}
                            linkFunc={linkf}
                        >
                            {callToAction.text}
                        </Button>
                    )}
                </div>
            </div>

        </BackgroundImage>
    )
}